export default __webpack_public_path__ + "src/images/btn_students-8140cc.png";